import SectionHeaderTitle from "@components/Section/SectionHeaderTitle";
import { AspectRatio } from "@mantine/core";
import React from "react";
import { ReactComponent as InfoIcon } from "@assets/icons/info_bolded.svg";
import { Link } from "react-router-dom";
import Footer from "@components/layout/Footer";

type ActivityInformationSubmitedProps = {};

const ActivityInformationSubmited: React.FC<
  ActivityInformationSubmitedProps
> = () => {
  return (
    <section>
      <div>
        <div className="w-full relative overflow-hidden">
          <div className="bg-blue-500 h-[280px] w-full" />
          <div className="absolute top-[47%] left-0 right-0 w-full">
            <AspectRatio ratio={16 / 9}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="42"
                viewBox="0 0 375 42"
                fill="none"
              >
                <path
                  d="M75.399 331.369C250.199 298.993 335.857 123.093 536.034 63.155L530.95 35.5147C323.374 75.8681 158.833 -32.7349 -6.24216 11.1731C-72.968 31.1529 -107.019 73.6584 -122.139 125.995C-146.564 210.537 -99.1907 302.739 -18.8191 325.958C9.31538 334.087 43.7863 335.321 75.399 331.369Z"
                  fill="#F8F7F3"
                />
              </svg>
            </AspectRatio>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-y-6">
        <SectionHeaderTitle
          label="Your application was submitted!"
          description={
            <div className="flex flex-col gap-y-6 text-pn-headline-regular text-pn_gray-600">
              <span>
                Emily, you've taken a wonderful step towards securing your
                future. We'll send you a confirmation email once we receive your
                details from your payroll team.
              </span>
              <span>
                Once your pension is activated, you'll be able to see your
                monthly contributions being deducted from your salary.
              </span>
            </div>
          }
        />
      </div>

      <div className="p-4 flex flex-col gap-y-6">
        <div className="bg-pn_paper-3 rounded-full w-10 h-10 flex items-center justify-center">
          <InfoIcon />
        </div>
        <span className="text-pn-body-regular">
          If you're eager to learn more about managing your pension and making
          the most of your financial future, explore our comprehensive guides,
          inspiring success stories, and useful tips on our website.
        </span>
        <Link
          to="/pension-application"
          className="btn-secondary-lg text-center"
        >
          See What's Next
        </Link>
      </div>

      <Footer />
    </section>
  );
};
export default ActivityInformationSubmited;
